module.exports = __webpack_public_path__ + "media/images/shopify_faq_4-c54a41f0597a05cb02035cca94bb80bd.png";